<template>
<div class="yo-bg-color-tertiary" style="padding:30px;">
  
  <h4 class="yo-font-roboto" style="margin:20px 0;">Iscriviti alla Newsletter</h4>


   <el-form ref="formAnagrafica" :model="contatto" @submit.native.prevent="onSubmit" :rules="rulesForm" label-width="180px">
 
      <div class="row pad" style="">
            
         <div class="col s12 m6">
         <el-form-item label="Cognome" prop="cognome">
         <el-input  v-model="contatto.cognome"></el-input>
         </el-form-item>
         </div> 

         <div class="col s12 m6">
         <el-form-item label="Nome" prop="nome">
         <el-input  v-model="contatto.nome"></el-input>
         </el-form-item>
         </div> 
  
         <div class="col s12 m6">
         <el-form-item label="Email" prop="email">
         <el-input  v-model="contatto.email"></el-input>
         </el-form-item>
         </div> 

         <div class="col s12 m6">
         <el-form-item label="Reinserisci Email" prop="emailcheck" >
         <el-input  v-model="contatto.emailcheck"></el-input>
         </el-form-item>
         </div> 

         <div class="col s12 m6 clear">
         <el-form-item label="Professionista sanitario" prop="sanitario">
         <el-select v-model="contatto.sanitario"  placeholder="Selezionare dalla lista" style="width:100%;">
            <el-option label="No" :value="0" ></el-option>
            <el-option label="Si" :value="1" ></el-option>
         </el-select>
         </el-form-item>
         </div>


         <div class="col s2 yo-align-right clear"> <el-form-item label="" class="no-label" prop="authnl">
          <!-- <el-checkbox v-model="contatto.authnl" :true-label="authcheck" false-label=""></el-checkbox> -->
          </el-form-item>
        </div>
        <div class="col s10" style="padding-bottom:20px;padding-top:8px;">
          L'informativa sulla privacy è consultabile <a href="/corsi-convegni/NLprivacy.pdf" target="_blank">cliccando qui</a>

          <!-- Ho letto l'Informativa sulla <a href="/eventi/NLprivacy.pdf" target="_blank">Privacy</a> e acconsento al trattamento dei dati personali ex art. 13 D.Lgs. 30/06/2003 n.196 -->
        </div>

        <!--

         <div class="col s12">
         <el-form-item label="Nazione" prop="nazione" >
         <el-select v-model="contatto.nazione"  placeholder="Selezionare dalla lista" style="width:100%;" filterable clearable >
            <el-option v-for="item in $nazioni" :key="item.id" :label="item.label" :value="item.id" ></el-option>
         </el-select>
         </el-form-item>
         </div>

         <div class="col s12">
         <el-form-item label="Interesse" prop="interesse" >
         <el-select v-model="contatto.interesse"  placeholder="Selezionare dalla lista" style="width:100%;" filterable clearable multiple>
            <el-option v-for="item in $teras._interesse" :key="item.id" :label="item.nome" :value="item.id" ></el-option>
         </el-select>
         </el-form-item>
         </div>

        -->
        <!--
         <div class="col s12" v-if="$contatto.row.provincia!=''">
         <el-form-item label="Città" prop="citta">
         <el-input  v-model="$contatto.row.citta" v-if="$contatto.row.provincia=='EE'"></el-input>
         <el-select v-model="$contatto.row.citta" v-else placeholder="Selezionare dalla lista" style="width:100%;" filterable clearable>
            <el-option v-for="(item,index) in $comune" :key="index" :label="item.comune" :value="item.comune" v-if="item.provincia==$contatto.row.provincia"></el-option>
         </el-select>
         </el-form-item>
         </div> 
         -->
<!--
         <div class="col s12 m6">
         <el-form-item label="Data di nascita" prop="natodata" class="is-required">
         <el-date-picker v-model="$contatto.row.natodata" type="date" placeholder="dd-mm-yyyy" style="width:100%;" format="dd-MM-yyyy" value-format="yyyy-MM-dd" ></el-date-picker>
         </el-form-item>
         </div> 

         <div class="col s12 m6">
         <el-form-item label="Sesso" prop="sesso">
         <el-select v-model="$contatto.row.sesso"  placeholder="Selezionare dalla lista" style="width:100%;">
            <el-option label="Maschio" value="M" ></el-option>
            <el-option label="Femmina" value="F" ></el-option>
         </el-select>
         </el-form-item>
         </div> 

         <div class="col s12 m6">
         <el-form-item label="Luogo di nascita" prop="natocitta">
         <el-input  v-model="$contatto.row.natocitta"></el-input>
         </el-form-item>
         </div> 

         <div class="col s12 m6">
         <el-form-item label="Codice Fiscale" prop="codicefiscale">
         <el-input  v-model="$contatto.row.codicefiscale"></el-input>
         </el-form-item>
         </div>

         <div class="col s12">
         <el-form-item label="Indirizzo" prop="indirizzo">
         <el-input  v-model="$contatto.row.address"></el-input>
         </el-form-item>
         </div>

         <div class="col s12 m6">
         <el-form-item label="CAP" prop="cap">
         <el-input  v-model="$contatto.row.cap"></el-input>
         </el-form-item>
         </div> 
         
         <div class="col s12 m6">
         <el-form-item label="Provincia" >
         <el-select v-model="$contatto.row.provincia"  placeholder="Selezionare dalla lista" style="width:100%;" filterable clearable v-on:change="$contatto.row.citta=''">
            <el-option v-for="item in $province" :key="item.id" :label="item.label" :value="item.id" ></el-option>
         </el-select>
         </el-form-item>
         </div> 

         <div class="col s12" v-if="$contatto.row.provincia!=''">
         <el-form-item label="Città" prop="citta">
         <el-input  v-model="$contatto.row.citta" v-if="$contatto.row.provincia=='EE'"></el-input>
         <el-select v-model="$contatto.row.citta" v-else placeholder="Selezionare dalla lista" style="width:100%;" filterable clearable>
            <el-option v-for="(item,index) in $comune" :key="index" :label="item.comune" :value="item.comune" v-if="item.provincia==$contatto.row.provincia"></el-option>
         </el-select>
         </el-form-item>
         </div> 
         

         <div class="col s12 m6">
         <el-form-item label="Cellulare" prop="cellulare">
         <el-input  v-model="$contatto.row.cellulare"></el-input>
         </el-form-item>
         </div> 

         <div class="col s12 m6">
         <el-form-item label="Telefono Casa" prop="telefono">
         <el-input  v-model="$contatto.row.telefono"></el-input>
         </el-form-item>
         </div> 
-->
      </div>

      <div class="row" style="margin-top:20px;border-top:1px solid #379EC2;padding-top:20px;">           
         <div class="col s12 m3">
                <router-link to="/"><el-button style="width:100%;"  >Indietro</el-button></router-link>
            </div> 
         <div class="col s12 m4 offset-m5">
            <el-button type="primary" @click="onSubmit" class="yo-bg-color-secondary" style="width:100%;border:none;">Continua</el-button>
         </div>
      </div>

   </el-form>
    


</div>
</template>

<script>


export default {
  name: 'nl-edit',
  components: {
  },
  data() {
    return {
      stepEdit: 0
      ,loading: {}
      ,authcheck: this.$moment().format('YYYY-MM-DD')
      ,checkAuth: (rule, value, callback) => {
        console.log("VERIFICO LA DATA")

         if(typeof value !='undefined')
          if(this.$moment().format('YYYY-MM-DD')!=value) {
              return callback(new Error('Errore generico di controllo'));
          }else{
              callback();
          }
      }
      ,contatto:{
        cognome:'',nome:'',email:'',emailcheck:'',authnl:this.$moment().format('YYYY-MM-DD'),nazione:'ITA',sanitario:1
      },
      checkEmail: (rule, value, callback) => {
         if(typeof value !='undefined')
            if (value.toString()!=this.contatto.email) {
               return callback(new Error('L\'indirizzo email di controllo non corrispondende all\'indirizzo email!'));
            }else{
               callback();
            }
      }
    }
  },
  created () {
    this.$teras.page.title = "Iscriviti alla Newsletter"
      this.$teras.page.sezione = "Newsletter"
    if(this.contatto.email!='')
      this.emailcheck = this.contatto.email

    
  },
  methods: {   
    onSubmit(){
      this.$refs.formAnagrafica.validate((valid) => {
        if (valid) {
          this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
          console.log(this.contatto)
          this.axios.saveRow({
          cognome:this.contatto.cognome,nome:this.contatto.nome,email:this.contatto.email,authnl:this.contatto.authnl,sanitario:this.contatto.sanitario
          },'contattonl').then((response) =>  {
            var api = response.data
            console.log(api.data)
            this.loading.close()
            this.$alert('Complimenti, iscrizione riuscita!','OPERAZIONE COMPLETATA',{type: 'success'}) 
            this.$router.push('/')
            //this.$teras.event.emit('contatto-saved',this.$contatto.row.step)
          })
          



          
        }else{
          this.$alert('Non tutti i dati sono stati inseriti in maniera corretta!','ERRORE',{type: 'error'}) 
        }
      })
    }

  },
  computed: {
     
    rulesForm:function() {
      var rulesNow = {
        authnl: [
          { validator:this.checkAuth, message: 'L\'accettazione della privacy è obbligatoria' , trigger:"change,blur" }
        ],
        cognome: [
          { required: true, message: 'Il cognome è obbligatorio' }
        ],
        nome: [
          { required: true, message: 'Il nome è obbligatorio'}
        ],
        emailcheck: [
          { required: true, message: 'L\'indirizzo email di controllo è obbligatorio'},
          { validator: this.checkEmail, message: 'L\'indirizzo email di controllo non è uguale all\'indirizzo email', trigger:"change" }
        ],     
        email: [
          { required: true, message: 'L\'indirizzo email è obbligatorio'},
          { type: 'email', message: 'Inserire un indirizzo email corretto', trigger: 'blur,change' },
          //{ validator: this.checkEmailExist,  trigger:"change" }
          
        ]
        
      }
      return rulesNow
    }
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/Nl-edit.vue